import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Maintenance from "../pages/maintenance/page";
import Contact from "../pages/contact/page";
import About from '../pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/maintenance',
    element: <Maintenance />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
